import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupMex from "../../Components/SavePopup";
import Spinner from "../../Components/Spinner";

const NewSupport = () => {
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate()
    const [caseType, selectCaseType] = useState("db");
    const [message, setMessage] = useState("");
    const [popupType, setPopupType] = useState("success")
    const [popupActive, setPopupActive] = useState(false)
    const [popupMex, setPopupMex] = useState("")
    const [loading, setLoading] = useState(false)

    const goBack = () => {
        navigate("/control_panel/support")
    }

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/new_ticket", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    caseType,
                    message,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to submit ticket.");
            }

            const result = await response.json();

            setPopupType("success")
            setPopupActive(true)
            setPopupMex("")
            setTimeout(() => {
                selectCaseType("db");
                setMessage("");
                goBack()
            }, 5000);
            setLoading(false)
        } catch (error) {
            setPopupType("error")
            setPopupActive(true)
            setPopupMex("Error submitting ticket")
            setLoading(false)
        }
    };

    const handlePopupClose = () => {
        setPopupActive(false);
    };

    return (
        <div className="middle_cont_main">
            <PopupMex
                active={popupActive} type={popupType} message={popupMex}
                onClose={handlePopupClose}
            />
            <p className="new_section_main_view_title"> <i
                className="fa-solid fa-chevron-left"
                onClick={goBack}
            ></i>{" "} New ticket</p>
            <p className="new_section_main_view_subtitle">Choose a case type and insert your message.</p>
            <div className="ticket_cases">
                {[
                    { type: "codespace", title: "Codespace AI", desc: "AI and Codespace issues" },
                    { type: "db", title: "Database", desc: "Database issues" },
                    { type: "collection", title: "Collection", desc: "Collection issues" },
                    { type: "apis", title: "Access", desc: "APIs and Keys" },
                    { type: "billing", title: "Billing", desc: "Billing and payments" },
                    { type: "general", title: "General", desc: "General issues" },
                ].map(({ type, title, desc }) => (
                    <div
                        key={type}
                        className={`ticket_case ${caseType === type ? "ticket_case_selected" : ""}`}
                        onClick={() => selectCaseType(type)}
                    >
                        <p className="ticket_title">{title}</p>
                        <p className="ticket_desc">{desc}</p>
                    </div>
                ))}
            </div>
            <textarea
                className="ticket_input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Describe your issue..."
            ></textarea>
            <div className="middle_container_btn_cont">
                <button className="support_btn" onClick={handleSubmit}>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) :
                        <>Submit ticket</>
                    }

                </button>
            </div>
        </div>
    );
};

export default NewSupport;
